import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useBrainEmbassyAnalytics } from "./brain-embassy_analytics";
import { partnerConfig } from "./brain-embassy_partner_config";

const Theme = lazyWithRetry(() => import("./brain-embassy_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 10", value: { minCapacity: 1, maxCapacity: 10 } },
  { label: "10+", value: { minCapacity: 11 } },
];

export function OfferingBrainEmbassyListingMeetingRoom() {
  useBrainEmbassyAnalytics();
  const { locale } = useI18n();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title:
            locale.baseLanguageTag === "pl"
              ? "Sale konferencyjne"
              : "Meeting Rooms",
          description:
            locale.baseLanguageTag === "pl"
              ? "Looking for a place to conduct job interviews, assessment days, meetings or important presentations, in a unique, creative and inspiring atmosphere? Just bring the content, we'll take care of all the rest."
              : "Szukasz miejsca do przeprowadzenia rozmów kwalifikacyjnych, dni adaptacyjnych, spotkań lub ważnych prezentacji w wyjątkowej, kreatywnej i inspirującej atmosferze? Po prostu przyjdź do Brain Embassy, a my zajmiemy się resztą.",
        }}
      />
    </Fragment>
  );
}
